var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _rect3, _path15, _path16, _path17, _rect4, _path18, _path19, _path20, _path21, _path22, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 81 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6017 35.5939C15.6017 36.1225 15.7976 36.6375 16.1896 37.1388C16.7182 37.7951 17.4246 38.1278 18.3087 38.1369V36.6193C17.771 36.6193 17.4018 36.3823 17.2013 35.9084C17.1466 35.7808 17.1193 35.6759 17.1193 35.5939V30.9865C17.1193 30.7404 17.2332 30.5034 17.4611 30.2755C17.698 30.0659 17.9806 29.9565 18.3087 29.9474V28.4298C17.2788 28.4298 16.504 28.8673 15.9845 29.7423C15.7293 30.1707 15.6017 30.5854 15.6017 30.9865V35.5939ZM19.006 38.1369C19.726 38.1369 20.3504 37.8543 20.879 37.2892C21.3348 36.7879 21.5626 36.2183 21.5626 35.5802L20.0861 35.2248C20.0861 35.325 20.0815 35.3888 20.0724 35.4162C20.0724 35.6076 20.0496 35.7716 20.004 35.9084C19.9311 36.0906 19.8126 36.241 19.6486 36.3595C19.4845 36.478 19.3341 36.5509 19.1974 36.5783L19.006 36.6193V38.1369ZM19.006 29.9474C19.006 29.9474 19.1245 29.9839 19.3615 30.0568C19.6713 30.2117 19.8855 30.435 20.004 30.7267C20.0496 30.8634 20.0724 31.0184 20.0724 31.1916V31.3966L21.5626 31.0138C21.5626 30.312 21.271 29.6877 20.6876 29.1408C20.1681 28.6668 19.6075 28.4298 19.006 28.4298V29.9474ZM23.5286 38.0685V28.3478H25.0872V38.0685H23.5286ZM27.3677 29.4416C27.3677 29.1043 27.5181 28.8628 27.8189 28.7169C27.9374 28.6623 28.0559 28.6349 28.1743 28.6349C28.5207 28.6349 28.7668 28.7853 28.9126 29.0861C28.9673 29.2046 28.9947 29.3231 28.9947 29.4416C28.9947 29.7697 28.8397 30.0067 28.5298 30.1525C28.4113 30.2072 28.2928 30.2345 28.1743 30.2345C27.8462 30.2345 27.6047 30.0887 27.4497 29.797C27.395 29.6877 27.3677 29.5692 27.3677 29.4416ZM27.4634 38.0685V30.7814H28.9263V38.0685H27.4634ZM31.2068 36.0041C31.2068 36.478 31.3936 36.9201 31.7673 37.3302C32.223 37.8224 32.8246 38.0685 33.572 38.0685V36.674C33.098 36.674 32.8018 36.5145 32.6833 36.1955C32.656 36.1317 32.6423 36.0679 32.6423 36.0041V32.5724C32.6423 32.3263 32.7745 32.1349 33.0388 31.9982C33.1937 31.9162 33.3715 31.8752 33.572 31.8752V30.4943C32.6788 30.4943 32.0043 30.8498 31.5486 31.5607C31.3298 31.8979 31.2159 32.2261 31.2068 32.5451V36.0041ZM34.1872 31.8888C34.6247 31.8888 34.8891 32.0939 34.9802 32.5041C34.9984 32.577 35.0075 32.6499 35.0075 32.7228V33.1056L36.3474 32.5998C36.3474 31.9253 36.0739 31.3739 35.5271 30.9455C35.126 30.6447 34.6794 30.4943 34.1872 30.4943V31.8888ZM34.1872 38.0822C34.8344 38.1004 35.404 37.8589 35.8962 37.3576C36.3064 36.9383 36.5114 36.4735 36.5114 35.963L35.1716 35.4572V35.8263C35.126 36.3914 34.7979 36.6785 34.1872 36.6877V38.0822ZM42.6857 38.0685V28.4982H44.2169V38.0685H42.6857ZM44.9142 34.0353V32.6681H45.6798C46.4728 32.6681 46.9103 32.2899 46.9923 31.5334C47.0014 31.4513 47.006 31.3739 47.006 31.3009C47.006 30.5353 46.6596 30.0841 45.9669 29.9474C45.8393 29.9292 45.7072 29.9201 45.5704 29.9201H44.9142V28.4982H45.7482C46.9604 28.5255 47.7762 28.9767 48.1954 29.8517C48.3686 30.2163 48.4552 30.6356 48.4552 31.1095C48.4461 32.1212 48.1362 32.855 47.5255 33.3107C47.9995 33.5841 48.3003 34.0718 48.4279 34.7736C48.4461 34.8921 48.4598 35.0015 48.4689 35.1017L48.7013 38.0685H47.2794L47.0743 35.6349C47.0014 34.8693 46.7963 34.3862 46.4591 34.1857C46.2586 34.0854 46.0079 34.0353 45.7072 34.0353H44.9142ZM50.5989 36.0041V32.5314C50.6172 32.0848 50.8223 31.6518 51.2142 31.2326C51.6973 30.7495 52.2806 30.5034 52.9642 30.4943V31.8615C52.6087 31.8615 52.3398 32.021 52.1575 32.34C52.0937 32.4494 52.0618 32.5496 52.0618 32.6408V33.4611H54.6595V32.6544C54.6595 32.2716 54.4499 32.021 54.0306 31.9025C53.9121 31.866 53.7936 31.8478 53.6751 31.8478V30.4943C54.3223 30.4943 54.8965 30.7176 55.3978 31.1642C55.817 31.5653 56.0312 32.0164 56.0404 32.5177V34.8693H52.0618V36.0041C52.0618 36.241 52.194 36.437 52.4583 36.5919C52.6224 36.6831 52.8001 36.7287 52.9915 36.7287V38.0685C52.1439 38.0685 51.4739 37.7267 50.9818 37.0431C50.7266 36.6694 50.5989 36.3231 50.5989 36.0041ZM53.6751 38.0685V36.715C54.2038 36.715 54.5684 36.4917 54.7689 36.0451C54.7962 35.9813 54.819 35.922 54.8372 35.8673L56.054 36.3048C55.89 36.9246 55.5208 37.4031 54.9466 37.7404C54.5547 37.9591 54.1309 38.0685 53.6751 38.0685ZM58.1431 38.0685V32.5451C58.1431 32.1076 58.3436 31.6746 58.7447 31.2462C59.2368 30.7358 59.8475 30.4761 60.5767 30.4669V31.9162C60.1574 31.9162 59.8657 32.0802 59.7017 32.4084C59.647 32.5177 59.6197 32.6225 59.6197 32.7228V38.0685H58.1431ZM61.1782 31.9162V30.4669C62.0441 30.4669 62.7232 30.8179 63.2154 31.5197C63.4797 31.8843 63.6118 32.2261 63.6118 32.5451V38.0685H62.1353V32.7228C62.1353 32.4494 62.0031 32.2306 61.7388 32.0666C61.5747 31.9663 61.3879 31.9162 61.1782 31.9162ZM65.4001 31.9435V30.5353H66.3298V28.3478H67.779V30.5353H68.6814V31.9572H67.779L67.7927 35.7443C67.8109 36.2912 68.0844 36.5692 68.613 36.5783H68.9001L69.2282 38.0685H68.5857C67.4281 38.0685 66.7217 37.6265 66.4665 36.7423C66.3754 36.4233 66.3298 36.0451 66.3298 35.6076V31.9435H65.4001Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8835,
    y: 1,
    width: 6.58904,
    height: 19.7671,
    fill: "#B6A340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.7672L7.58904 20.7672",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58899 1L7.58899 20.7671",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58899 1L17.4725 0.999999",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 1V20.7671",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 20.7672H24.0617",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0616 12.5309V20.6558",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.298 1V12.5308",
    stroke: "white",
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1815 20.7672H48.7706",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7706 7.58902V20.4599",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0068 20.7672H63.5959",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5958 7.58902V20.7671",
    stroke: "white",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5958 7.58904L68.5376 1",
    stroke: "white",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4795 20.7672H80.0685",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3561,
    y: 12.5309,
    width: 14.8253,
    height: 8.2363,
    fill: "#B6A340"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5925,
    y: 1,
    width: 6.58904,
    height: 11.5308,
    fill: "#B6A340"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0616 12.0309C23.7855 12.0309 23.5616 12.2547 23.5616 12.5309C23.5616 12.807 23.7855 13.0309 24.0616 13.0309V12.0309ZM32.2979 13.0309H32.7979V12.0309H32.2979V13.0309ZM24.0616 13.0309H32.2979V12.0309H24.0616V13.0309Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1815 1L42.1815 20.7671",
    stroke: "white",
    strokeLinecap: "square"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.298 1H42.1815",
    stroke: "white",
    strokeLinecap: "square"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52.065,
    y: 7.58902,
    width: 4.94178,
    height: 13.1781,
    fill: "#B6A340"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9817 7.60281L57.0068 20.7671",
    stroke: "white",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7706 7.58902H56.9059",
    stroke: "white",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8904 7.58906L70.1849 2.64728L73.4794 7.58906V20.7671H66.8904V7.58906Z",
    fill: "#B6A340"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4795 7.58902V20.7671",
    stroke: "white",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5377 1L73.4794 7.58904",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0685,
    y: 4.06851,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0685,
    y: 4.06851,
    width: 3,
    height: 4,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0685,
    y: 17.0685,
    width: 1,
    height: 4,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0685,
    y: 17.0685,
    width: 2,
    height: 4,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 54.0685,
    y: 9.06851,
    width: 1,
    height: 2,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0685,
    y: 11.0685,
    width: 3,
    height: 3,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0685,
    y: 14.0685,
    width: 3,
    height: 7,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0685,
    y: 11.0685,
    width: 4,
    height: 3,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5685,
    cy: 7.56851,
    r: 1.5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77ce73e0b6ef91375877a71ca1d507b2.svg";
export { ForwardRef as ReactComponent };